export default "__VITE_ASSET__DMRlqZ88__"